import React from "react";
import "./AboutMe.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileArrowDown } from "@fortawesome/free-solid-svg-icons";
import { faCode } from "@fortawesome/free-solid-svg-icons";

const AboutMe = () => {
   const handleDownLoadCV = () => {
      alert("Updating CV, please check back later!");
   }
   return (
      <section id="about" className="about-section">
         <div className="about-container">
            <div className="about-title">
               <h1>About Me</h1>
            </div>
            <div className="about-content">
               <div className="about-left">
                  <div className="about-left-top">
                     <h2>Hi, I'm</h2>
                     <h3>Bui Quoc Khanh</h3>
                     <p>
                        One of my strengths is that I’m a quick learner. I can adapt to new technologies or frameworks
                        quickly, especially in a fast-paced environment. I also have strong communication skills, which
                        help me work well in a team and express ideas clearly. As for my weakness, T tends to be a
                        perfectionist, which sometimes slows me down. However, I’m learning to balance quality with
                        efficiency by setting time limits and focusing on priorities.
                     </p>
                  </div>
                  <div className="about-left-middle" >
                     <button onClick={handleDownLoadCV}
                       // href="/cv/BuiQuocKhanh_CV.pdf"
                        //download
                        className="about-cv-btn"
                     >
                        <FontAwesomeIcon icon={faFileArrowDown} className="icon" /> Download CV
                       
                     </button>
                     <a
                        href="#" // Đường dẫn trang bạn muốn chuyển hướng
                        target="_blank"
                        rel="noopener noreferrer"
                        className="about-visit-btn"
                     >
                        <FontAwesomeIcon icon={faCode} /> Visit Projects
                     </a>
                  </div>
                  <div class="about-left-bottom">
                     <div class="about-info-card">
                        <div class="info-icon">
                           <span>&lt;/&gt;</span>
                        </div>
                        <div class="info-title">TOTAL PROJECTS</div>
                        <div class="info-value">3</div>
                     </div>

                     <div class="about-info-card">
                        <div class="info-icon">
                           <span>🎖️</span>
                        </div>
                        <div class="info-title">CERTIFICATES</div>

                        <div class="info-value">4</div>
                     </div>

                     <div class="about-info-card">
                        <div class="info-icon">
                           <span>🌐</span>
                        </div>
                        <div class="info-title">YEARS OF EXPERIENCE</div>

                        <div class="info-value">2</div>
                     </div>
                  </div>
               </div>
               <div className="about-right"></div>
            </div>
         </div>
      </section>
   );
};

export default AboutMe;
